import { Search } from "lucide-react";

export default function CommandBar({
  query,
  onQuery,
  category,
  onCategory,
  categories,
  weeks,
  onWeeks,
  marketsCount,
  totalCount,
}) {
  return (
    <div
      className="border border-zinc-800 bg-[#09090B] p-2 flex items-center gap-2 flex-wrap"
      data-testid="command-bar"
    >
      <div className="flex items-center gap-2 flex-1 min-w-[200px]">
        <Search size={14} strokeWidth={1.5} className="text-zinc-500" />
        <input
          data-testid="search-input"
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          placeholder="SEARCH MARKET / SYMBOL"
          className="w-full bg-black border border-zinc-800 px-2 py-1.5 text-xs uppercase tracking-wider rounded-none focus:border-zinc-500 focus:outline-none focus:ring-0 placeholder:text-zinc-600"
        />
      </div>

      <div className="flex items-center gap-1 flex-wrap" data-testid="category-tabs">
        {categories.map((c) => {
          const active = c === category;
          return (
            <button
              key={c}
              data-testid={`category-${c.toLowerCase()}`}
              onClick={() => onCategory(c)}
              className={`px-2.5 py-1 text-[11px] uppercase tracking-widest border transition-none ${
                active
                  ? "border-amber-500 bg-amber-500/10 text-amber-term"
                  : "border-zinc-800 text-zinc-400 hover:border-zinc-600 hover:text-zinc-100"
              }`}
            >
              {c}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-1" data-testid="weeks-tabs">
        <span className="text-[11px] uppercase tracking-widest text-zinc-500 pr-1">RANGE</span>
        {[12, 26, 52, 104].map((w) => {
          const active = w === weeks;
          return (
            <button
              key={w}
              data-testid={`weeks-${w}`}
              onClick={() => onWeeks(w)}
              className={`px-2 py-1 text-[11px] uppercase tracking-widest border ${
                active
                  ? "border-amber-500 bg-amber-500/10 text-amber-term"
                  : "border-zinc-800 text-zinc-400 hover:border-zinc-600"
              }`}
            >
              {w}W
            </button>
          );
        })}
      </div>

      <div
        className="text-[11px] uppercase tracking-widest text-zinc-500 ml-auto"
        data-testid="market-counter"
      >
        <span className="text-zinc-100">{marketsCount}</span>
        <span className="text-zinc-700"> / </span>
        <span>{totalCount} MARKETS</span>
      </div>
    </div>
  );
}
